import { render, staticRenderFns } from "./QuickFeatureCreate.vue?vue&type=template&id=1dc624b5&scoped=true"
import script from "./QuickFeatureCreate.vue?vue&type=script&lang=js"
export * from "./QuickFeatureCreate.vue?vue&type=script&lang=js"
import style0 from "./QuickFeatureCreate.vue?vue&type=style&index=0&id=1dc624b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc624b5",
  null
  
)

export default component.exports